import { hasActiveMobileForegroundTask } from './mobileRuntimeState'

let activeRegistration = null
let runtimeListenerInstalled = false
const requestedWorkers = new WeakSet()
const watchedWorkers = new WeakSet()

function activateMobileServiceWorkerUpdate() {
  if (hasActiveMobileForegroundTask()) return
  const waiting = activeRegistration?.waiting
  if (!waiting || requestedWorkers.has(waiting)) return
  // Pages use network-only navigation and content-hashed assets. Updating the
  // cache worker needs no reload, so drafts and reading positions stay intact.
  waiting.postMessage({ type: 'SKIP_WAITING' })
  requestedWorkers.add(waiting)
}

function watchInstallingWorker(registration) {
  const worker = registration.installing
  if (!worker || watchedWorkers.has(worker)) return
  watchedWorkers.add(worker)
  worker.addEventListener('statechange', () => {
    if (worker.state === 'installed') activateMobileServiceWorkerUpdate()
  })
}

export async function registerMobileServiceWorker() {
  if (
    process.env.NODE_ENV !== 'production'
    || typeof window === 'undefined'
    || !window.location.pathname.startsWith('/mobile/')
    || !('serviceWorker' in navigator)
  ) return null

  const registration = await navigator.serviceWorker.register('/mobile/mobile-service-worker.js', {
    scope: '/mobile/',
    updateViaCache: 'none'
  })
  activeRegistration = registration

  if (!runtimeListenerInstalled) {
    window.addEventListener('mobile-runtime-state', activateMobileServiceWorkerUpdate)
    runtimeListenerInstalled = true
  }
  activateMobileServiceWorkerUpdate()
  watchInstallingWorker(registration)
  registration.addEventListener('updatefound', () => {
    watchInstallingWorker(registration)
  })

  // An offline update check can fail while the current page remains usable.
  void registration.update().catch(() => {})
  return registration
}

export async function clearMobileUserCaches() {
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.getRegistration('/mobile/')
    registration?.active?.postMessage({ type: 'CLEAR_MOBILE_USER_CACHES' })
  }
}
